import $ from "jquery"

// モーダルボタンのイベントリスナー登録
document.addEventListener("turbo:load", function() {
  // turbo streamで追加されるhtmlに対してもイベントリスナーを登録するため、
  // document.bodyにイベントリスナーを登録する
  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".js-job-entry-btn")) {
      event.preventDefault();
      document.querySelector("[data-id='job-entry-modal-box']").classList.add('open');
    }
  })

  // MARK: 応募するモーダルの閉じるボタン
  $("[data-id='job-entry-modal-box-close']").on("click", function() {
    $("[data-id='job-entry-modal-box']").removeClass("open");
  });
});